import { LayoutMain } from "@unisearch/theme/layout";
import { ForgotNotify } from "@unisearch/auth/forgot-password";

const EmailNotify = () => {
  return (
    <LayoutMain
      title="Forget Password"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/forgot-password/email-notify`}
    >
      <ForgotNotify />
    </LayoutMain>
  );
};

export default EmailNotify;
